module.exports = __webpack_public_path__ + "img/gr-2.f0b8b1f8.png";